import { Modal } from "antd";
import { destroySessionPopups } from './actionableNotifications';
import { sessionIsCurrent, sessionTicket } from './sessionLifecycle';

// Every place that can show a notification popup registers how to clear it,
// so logging out removes them all at once: the static API, App.useApp()'s
// holder and the hook-based holders (chat messages, staff presence).
const dismissers = new Set();
const browserNotices = new Set();
export function trackBrowserNotification(notice) {
  const ticket = sessionTicket(), click = notice.onclick;
  browserNotices.add(notice);
  notice.addEventListener?.('close', () => browserNotices.delete(notice), { once: true });
  notice.onclick = event => { if (sessionIsCurrent(ticket)) click?.(event); else notice.close(); };
  return notice;
}

export function registerNotificationDismisser(dismiss) {
  dismissers.add(dismiss);
  return () => dismissers.delete(dismiss);
}

export function dismissAllNotifications() {
  browserNotices.forEach(notice => { try { notice.close(); } catch { } });
  browserNotices.clear();
  dismissers.forEach(dismiss => { try { dismiss(); } catch { } });
  destroySessionPopups();
  Modal?.destroyAll?.();
}
